const contactFormSpec = {
  formIdentifier: "landing-page-inquiries",
  mainTitleText: " ",
  mainTitleColor: "",
  secondaryTitleText: " ",
  sectionBg: "rgba(0, 0, 0, 0)",
  secondaryTitleColor: "#ffffff",
  textBeforeSubmitButton: "اترك لنا رسالتك لنتواصل معك في أقرب وقت ممكن",
  submitButtonColor: "#f2f2f2",
  submitButtonText: "إرسال",
  clearButtonColor: "#f2f2f2",
  clearButtonText: "الغاء",
  successMessage: "نشكر تواصلكم معنا!",
  failureMessage:
    "لم نتمكن من ارسال رسالتك! رجاءا قم بتحميل الصفحة وحاول مرة اخرى",
  inputs: [
    {
      name: "full_name",
      type: "text",
      label: "الإسم الكامل",
      placeholder: "الاسم الشخصي والعائلة",
      required: true,
    },
    {
      name: "user_email",
      type: "email",
      placeholder: "john@email.com",
      errorMessage: "رجاءا قم بإدخال عنوان بريد الكتروني",
      label: "بريد الكتروني",
      required: true,
    },
    {
      name: "user_phone",
      type: "text",
      placeholder: "0520001234",
      errorMessage: "رجاءا قم بإدخال رقم هاتف",
      label: "*رقم هاتف",
      required: true,
    },
    {
      name: "message",
      type: "textarea",
      placeholder: "قم بكتابة رسالتك",
      label: "رسالتك",
      rows: 5,
      required: true,
    },
  ],
};

export default contactFormSpec;
